'use strict';

import Parameter from '../Parameter';

class QueryParameter extends Parameter {

}

export default QueryParameter;
